// extracted by mini-css-extract-plugin
module.exports = {"w1918spn":"w1918spn","ivw4w97":"ivw4w97"};